import { groupsResourceType } from "@/modules/groups/api/resources/groupsResourceConsts";
import { GroupItemResource } from "@/modules/groups/api/resources/groupsResourceStruct";
import { GetTasksResponse } from "@/modules/tasks/api/queries/getTasksQuery";
import { subtaskResourceType } from "@/modules/tasks/api/resources/subtask/subtaskResourceConsts";
import { SubtaskResource } from "@/modules/tasks/api/resources/subtask/subtaskResourceStruct";

import { ParsedTasksItem } from "../../types/types";

import { parseDeadline } from "./parseDeadline";
import { parseSubtasks } from "./parseSubtasks";

export function parseTasksList(response: GetTasksResponse): ParsedTasksItem[] {
  const { data, included } = response;

  const parsedTasksList = data.map((taskItem) => {
    const taskGroupsIds = taskItem.relationships.userGroups.data.map(
      (userGroup) => userGroup.id
    );
    const taskGroups = included
      .filter(
        (item): item is GroupItemResource => item.type === groupsResourceType
      )
      .filter((group) => taskGroupsIds.includes(group.id))
      .map((group) => ({
        id: group.id,
        name: group.attributes.name,
        colorHex: group.attributes.colorHex,
      }));

    const itemSubtasksIds = taskItem.relationships.subtasks.data.map(
      (subtask) => subtask.id
    );

    const itemSubtasks = included
      .filter(
        (item): item is SubtaskResource => item.type === subtaskResourceType
      )
      .filter((subtask) => itemSubtasksIds.includes(subtask.id));

    const parsedSubtasks = parseSubtasks(itemSubtasks);
    return {
      id: taskItem.id,
      date: taskItem.attributes.date,
      groups: taskGroups,
      name: taskItem.attributes.name,
      deadline: taskItem.attributes.deadline
        ? parseDeadline(taskItem.attributes.deadline)
        : null,
      pointsNumber: taskItem.attributes.pointsNumber,
      progress:
        (parsedSubtasks.filter((subtask) => subtask.completedBy).length /
          parsedSubtasks.length) *
        100,
      subtasks: parsedSubtasks,
    };
  });
  return parsedTasksList;
}
